import { useEffect } from 'react'
import * as PropTypes from 'prop-types'
import { useTranslation } from 'react-i18next'

import RadioField from '../../FormLegacy/FormFieldsV2/RadioField'
import SelectField from '../../FormLegacy/FormFieldsV2/SelectField'
import { allowTwoDecimalsAfterDot } from '../helpers'

import { ModifiedPriceType } from './types'

const ReservationModifyPriceForm = ({
  type,
  value,
  onChangeType,
  onChangeValue,
  originalPrice,
}) => {
  const { t } = useTranslation(['reservations'])
  const handleValueUpdate = (value) => {
    const isValidValue = value !== '' && !isNaN(value.replace(',', '.'))
    if (isValidValue) {
      if (type === ModifiedPriceType.CustomPrice) {
        onChangeValue(value.replace(',', '.'))
        return
      }
      const maxValue = type === ModifiedPriceType.Discount ? originalPrice : 100
      onChangeValue(`${Math.max(Math.min(maxValue, Number(value)), 0)}`)
    } else {
      onChangeValue('')
    }
  }
  useEffect(() => {
    if (type !== ModifiedPriceType.CustomPrice) {
      handleValueUpdate(value)
    }
  }, [type])
  return (
    <div className="reservation-custom-price-form">
      <div className="reservation-custom-price-form__type">
        <RadioField
          name="custom-price"
          data-testid="custom-price"
          label={t('reservations:reservationModifyPriceForm.customPrice')}
          additionalClass="reservation-custom-price-form__radio-button"
          checked={type === ModifiedPriceType.CustomPrice}
          onChange={() => onChangeType(ModifiedPriceType.CustomPrice)}
        />
        <RadioField
          name="discount"
          data-testid="discount"
          label={t('reservations:reservationModifyPriceForm.discount')}
          additionalClass="reservation-custom-price-form__radio-button"
          checked={
            type === ModifiedPriceType.Discount || type === ModifiedPriceType.DiscountPercentage
          }
          onChange={() => onChangeType(ModifiedPriceType.Discount)}
        />
      </div>
      <div className="reservation-custom-price-form__inputs">
        <input
          placeholder={
            type === ModifiedPriceType.CustomPrice
              ? t('reservations:reservationModifyPriceForm.enterPreferredPrice')
              : t('reservations:reservationModifyPriceForm.enterPreferredDiscount')
          }
          type="text"
          value={value}
          onChange={({ target: { value } }) => {
            handleValueUpdate(allowTwoDecimalsAfterDot(value))
          }}
        />
        {type !== ModifiedPriceType.CustomPrice && (
          <SelectField
            name="discount-type"
            options={[
              {
                value: 'flat-rate',
                label: t('reservations:reservationModifyPriceForm.flatRateOption'),
              },
              {
                value: 'percentage',
                label: t('reservations:reservationModifyPriceForm.percentageOption'),
              },
            ]}
            placeholder={t('reservations:shared.selectPlaceholder')}
            onChange={({ target: { value } }) =>
              onChangeType(
                value === 'flat-rate'
                  ? ModifiedPriceType.Discount
                  : ModifiedPriceType.DiscountPercentage,
              )
            }
            value={type === ModifiedPriceType.Discount ? 'flat-rate' : 'percentage'}
          />
        )}
      </div>
    </div>
  )
}

ReservationModifyPriceForm.propTypes = {
  type: PropTypes.string,
  value: PropTypes.string,
  onChangeType: PropTypes.func,
  onChangeValue: PropTypes.func,
  originalPrice: PropTypes.number,
}

export default ReservationModifyPriceForm
